<h2 mat-dialog-title>{{ 'FRONTEND.SALES_UI.SELECT_TAG' | translate }}</h2>
<mat-dialog-content>
  <mat-form-field>
    <mat-label>{{ 'FRONTEND.SALES_UI.TAG' | translate }}</mat-label>
    <mat-select [compareWith]="compareObjects" [formControl]="formControl" multiple>
      <mat-option *ngFor="let tag of tagOptions$ | async" [value]="tag">
        {{ tag.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button color="primary" mat-button mat-dialog-close>
    {{ 'FRONTEND.SALES_UI.COMMON.ACTION_LABELS.CANCEL' | translate }}
  </button>
  <button (click)="save()" color="primary" mat-raised-button>
    {{ 'FRONTEND.SALES_UI.COMMON.ACTION_LABELS.SAVE' | translate }}
  </button>
</mat-dialog-actions>
